// Draait het portaal in een gewoon browsertabblad, of als geïnstalleerde app (PWA)?
//
// Gebruikt door het rechtsklikmenu (Customer 360 / Metering). Het is even in-app
// navigeren geweest (17-08-2026) omdat een nieuw tabblad een verse app-load met
// welkomstscherm betekende, maar een eigen tabblad is precies waarvoor dat menu
// dient: de lijst waar je op klikte blijft staan. De laadtijd is aan de andere
// kant opgelost — de deep-link-tab haalt eerst alleen zijn doel op en stelt het
// zware achtergrondladen uit (zie "Snelle start bij een deep-link" in App.jsx).
//
// WAAROM DIT BESTAAT: Chrome "vangt" een klik op een link naar een URL binnen de
// scope van een geïnstalleerde PWA af en opent die in het APPVENSTER — ook vanuit
// een gewoon browsertabblad, en ook als de link `target="_blank"` draagt. Wie in
// de browser werkte en in het rechtsklikmenu op Customer 360 klikte, zag daardoor
// plots het appvenster openspringen. Zie
// https://developer.chrome.com/docs/capabilities/pwa-navigation-management
//
// De acties die naar een pagina van het portaal zelf springen kiezen daarom zelf
// waar ze landen: werk je in de app, dan blijf je in de app; werk je in de
// browser, dan krijg je een browsertabblad.
//
// display-mode 'browser' = gewoon tabblad. Elke andere modus is een appvenster;
// `window-controls-overlay` en `minimal-ui` horen daar dus ook bij. Op iOS kent
// Safari geen display-mode voor "toevoegen aan beginscherm" — daar is
// navigator.standalone de enige aanwijzing.
const APP_MODI = ['standalone', 'minimal-ui', 'fullscreen', 'window-controls-overlay'];

export function isStandaloneApp() {
  try {
    if (typeof window === 'undefined') return false;
    if (window.navigator && window.navigator.standalone === true) return true;   // iOS
    if (typeof window.matchMedia !== 'function') return false;
    return APP_MODI.some((m) => window.matchMedia(`(display-mode: ${m})`).matches);
  } catch {
    // Een browser zonder matchMedia of met een afgeschermde media-query: dan liever
    // "browser" aannemen. Dat is de veilige kant — een browsertabblad kan altijd,
    // een appvenster niet.
    return false;
  }
}

// Opent een pagina van het portaal zélf op de plek die bij de huidige omgeving hoort.
//   - app     → `inApp()`: navigeren binnen het appvenster (geen tweede venster).
//   - browser → een nieuw browsertabblad.
// Het tabblad gaat bewust via window.open() en NIET via de link zelf: een via
// script geopend venster (mét opener — dus geen rel="noopener") valt buiten
// Chrome's link-capturing en blijft dus een gewoon tabblad. Wordt de popup
// geblokkeerd, dan navigeren we in het huidige tabblad; dat is nog altijd beter
// dan een klik die niets doet.
export function openPortalPage(url, inApp) {
  if (isStandaloneApp()) { inApp(); return; }
  const w = window.open(url, '_blank');
  if (!w) window.location.assign(url);
}
